"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHOW_TYPE_TIMEOUT = exports.SHOW_TYPE_PERCENT_SCROLLED_HIDE_AGAIN = exports.SHOW_TYPE_PERCENT_SCROLLED = exports.SHOW_TYPE_IMMEDIATELY = exports.SHOW_TYPE_HIDE = void 0;
const SHOW_TYPE_IMMEDIATELY = exports.SHOW_TYPE_IMMEDIATELY = 'immediately';
const SHOW_TYPE_HIDE = exports.SHOW_TYPE_HIDE = 'hide';
const SHOW_TYPE_PERCENT_SCROLLED = exports.SHOW_TYPE_PERCENT_SCROLLED = 'percentScrolled';
const SHOW_TYPE_PERCENT_SCROLLED_HIDE_AGAIN = exports.SHOW_TYPE_PERCENT_SCROLLED_HIDE_AGAIN = 'percentScrolledHideAgain';
const SHOW_TYPE_TIMEOUT = exports.SHOW_TYPE_TIMEOUT = 'timeOnPageInSeconds';